import React, { useState } from 'react'
import { createContext } from 'react'
import { SelectedProduct } from '../utils'

type ShoppingProviderProps = {
  children: React.ReactNode
}

type ChartType = {
  [priceId: string]: {
    key: string,
    product: SelectedProduct
    quantity: number,
    isValid: boolean
  }
}

type ShoppingContextType = {
  chart: ChartType
  setChart: React.Dispatch<React.SetStateAction<ChartType>>
}

export const ShoppingContext = createContext({} as ShoppingContextType)
export const useShopping = () => {
  const context = React.useContext(ShoppingContext)
  if (!context)
    throw new Error('useShopping must be used within a ShoppingProvider')

  const totalAmount = Object.values(context.chart).reduce((total, { product, quantity }) => {
    const unitPrice = parseFloat(product.price.unit_price.amount)
    return total + (unitPrice * quantity)
  }, 0)

  return {
    ...context,
    totalAmount
  }
}

export const ShoppingProvider = ({ children }: ShoppingProviderProps) => {
  const [chart, setChart] = useState<ChartType>({})
  
  return (
    <ShoppingContext.Provider
      value={{
        chart,
        setChart
      }}
    >
      {children}
    </ShoppingContext.Provider>
  )
}
